import React from "react";
import AppButton from "./AppButton.jsx";

export default function StateCard({
  state = "empty",
  message,
  onRetry,
  retryLabel = "Erneut versuchen",
  className = "",
}) {
  const cardClass = "rounded-2xl border border-default bg-surface";
  const textClass = state === "error" ? "text-red-600 dark:text-red-300" : "text-muted";

  return (
    <div className={`${cardClass} ${textClass} px-6 py-6 ${className}`.trim()}>
      <div className="flex items-center justify-between gap-3">
        <span>{message}</span>
        {state === "error" && onRetry ? (
          <AppButton variant="secondary" size="sm" onClick={onRetry}>
            {retryLabel}
          </AppButton>
        ) : null}
      </div>
    </div>
  );
}
